<style>
.select {
    background: var(--white);
    border: 1px solid;
    border-color: var(--neutral-1);
    border-radius: var(--internal-border-radius);
    box-sizing: border-box;
    color: var(--black);
    display: inline-flex;
    height: 36px;
    margin: 0;
    padding: 5px 10px;
    font: inherit;
}
.select:focus {
    outline: none;
}
.select--block {
    display: flex;
    width: 100%;
}

.select--dark {
    border-color: var(--black);
    color: var(--black);
}

.select--multiple {
    height: auto !important;
}
</style>

<template>
    <cp-slot-watcher childList attributes @change="handleOptionsChange">
        <select class="select" :class="className" :value="value" @input="handleInput" @change="handleChange" :multiple="multiple">
            <option v-if="valueNotPresent && !multiple" value="" disabled data-is-placeholder="true">- Select -</option>
            <slot />
        </select>
    </cp-slot-watcher>
</template>

<script>
export default {
    components: {
        CpSlotWatcher: require('./slot-watcher').default,
    },

    props: {
        value: [String, Number],
        block: Boolean,
        dark: Boolean,
        multiple: Boolean,
    },

    data() {
        return {
            options: [],
            justEmittedInput: false,
        };
    },

    computed: {
        className() {
            return {
                'select--block': this.block,
                'select--dark': this.dark,
                'select--multiple': this.multiple,
            };
        },

        valueNotPresent() {
            // Work around mobile Safari behavior when given a value that doesn't match an option.
            // See https://vuejs.org/v2/guide/forms.html#Select for more info.
            return !this.options.find((option) => option.value === `${this.value}` && !option.dataset.isPlaceholder);
        },
    },

    methods: {
        handleOptionsChange() {
            // Make a local copy to allow reactions to options changes.
            this.options = [...this.$el.options];
        },

        handleInput(event) {
            this.$emit('input', event.target.value);

            // Prevent double-emitting from the `handleChange` method.
            this.justEmittedInput = true;
            setTimeout(() => {
                this.justEmittedInput = false;
            }, 50);
        },

        handleChange(event) {
            // IE doesn't fire input events from selects.
            if (!this.justEmittedInput) {
                this.handleInput(...arguments);
            }

            this.$emit('change', event);
        },
    },
};
</script>
